import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'

export default {
  async getConfigurationExtended(configurationCode, deliveryDateTime) {
    const params = {
      configurationCode,
      deliveryDateTime,
    }

    try {
      const response = await axios.get('getConfigurationExtended', { params })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      }

      return Promise.reject(e)
    }
  },
  async getStockCarExtended(stockCarId, deliveryDateTime) {
    const params = {
      stockCarId: stockCarId,
      deliveryDateTime,
    }

    try {
      const response = await axios.get('getStockCarByIdExtended', { params })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      }

      return Promise.reject(e)
    }
  },
  async getNewStockExtended(stockId, deliveryDate, extendedConfiguration) {
    const params = {
      stockId: stockId,
      deliveryDateTime: deliveryDate,
      calculateBpm: true,
      extendedConfiguration: extendedConfiguration,
    }

    try {
      const response = await passThroughAxios.get('stockcarsNew/stock', { params })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
